module.exports = __webpack_public_path__ + "static/media/browse-electric-vehicles-no-hover.7f83bac8.svg";